import script from "./ClientsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./ClientsPanel.vue?vue&type=style&index=0&id=321593a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-321593a8"]])

export default __exports__